import { QUERY_PARAMS } from '@constants/query-params.const';

export const REGISTER_REQUIRED_PARAMS = [QUERY_PARAMS.INVITATION_TOKEN];
